const _excluded = ["accounts"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { Map as ImmutableMap, OrderedSet as ImmutableOrderedSet, Record as ImmutableRecord } from 'immutable';
import { FOLLOWERS_FETCH_SUCCESS, FOLLOWERS_EXPAND_SUCCESS, FOLLOWING_FETCH_SUCCESS, FOLLOWING_EXPAND_SUCCESS, FOLLOW_REQUESTS_FETCH_SUCCESS, FOLLOW_REQUESTS_EXPAND_SUCCESS, FOLLOW_REQUEST_AUTHORIZE_SUCCESS, FOLLOW_REQUEST_REJECT_SUCCESS, PINNED_ACCOUNTS_FETCH_SUCCESS, BIRTHDAY_REMINDERS_FETCH_SUCCESS, FOLLOW_REQUESTS_FETCH_REQUEST } from '../actions/accounts';
import { BLOCKS_FETCH_SUCCESS, BLOCKS_EXPAND_SUCCESS, BLOCKS_FETCH_REQUEST } from '../actions/blocks';
import { DIRECTORY_FETCH_REQUEST, DIRECTORY_FETCH_SUCCESS, DIRECTORY_FETCH_FAIL, DIRECTORY_EXPAND_REQUEST, DIRECTORY_EXPAND_SUCCESS, DIRECTORY_EXPAND_FAIL } from '../actions/directory';
import { FAMILIAR_FOLLOWERS_FETCH_SUCCESS } from '../actions/familiar_followers';
import { GROUP_MEMBERS_FETCH_SUCCESS, GROUP_MEMBERS_EXPAND_SUCCESS, GROUP_REMOVED_ACCOUNTS_FETCH_SUCCESS, GROUP_REMOVED_ACCOUNTS_EXPAND_SUCCESS, GROUP_REMOVED_ACCOUNTS_REMOVE_SUCCESS } from '../actions/groups';
import { REBLOGS_FETCH_SUCCESS, FAVOURITES_FETCH_SUCCESS, REACTIONS_FETCH_SUCCESS } from '../actions/interactions';
import { MUTES_FETCH_SUCCESS, MUTES_EXPAND_SUCCESS, MUTES_FETCH_REQUEST } from '../actions/mutes';
import { NOTIFICATIONS_UPDATE } from '../actions/notifications';
export const ListRecord = ImmutableRecord({
  next: null,
  items: ImmutableOrderedSet(),
  isLoading: false
});
export const ReactionRecord = ImmutableRecord({
  accounts: ImmutableOrderedSet(),
  count: 0,
  name: '',
  url: null
});
const ReactionListRecord = ImmutableRecord({
  next: null,
  items: ImmutableOrderedSet(),
  isLoading: false
});
export const ReducerRecord = ImmutableRecord({
  followers: ImmutableMap(),
  following: ImmutableMap(),
  reblogged_by: ImmutableMap(),
  favourited_by: ImmutableMap(),
  reactions: ImmutableMap(),
  follow_requests: ListRecord(),
  blocks: ListRecord(),
  mutes: ListRecord(),
  directory: ListRecord({
    isLoading: true
  }),
  groups: ImmutableMap(),
  groups_removed_accounts: ImmutableMap(),
  pinned: ImmutableMap(),
  birthday_reminders: ImmutableMap(),
  familiar_followers: ImmutableMap()
});
const loadingList = (state, path) => {
  const current = state.getIn(path);
  return state.setIn(path, current.set('isLoading', true));
};
const normalizeList = (state, path, accounts, next) => {
  return state.setIn(path, ListRecord({
    isLoading: false,
    next,
    items: ImmutableOrderedSet(accounts.map(item => item.id))
  }));
};
const appendToList = (state, path, accounts, next) => {
  return state.updateIn(path, map => {
    return map.set('next', next).update('items', list => list.concat(accounts.map(item => item.id)));
  });
};
const removeFromList = (state, path, accountId) => {
  return state.updateIn(path, map => {
    return map.update('items', list => list.filterNot(item => item === accountId));
  });
};
const normalizeFollowRequest = (state, notification) => {
  return state.updateIn(['follow_requests', 'items'], list => {
    return ImmutableOrderedSet([notification.account.id]).union(list);
  });
};
export default function userLists(state = ReducerRecord(), action) {
  switch (action.type) {
    case BLOCKS_FETCH_REQUEST:
      return loadingList(state, ['blocks']);
    case MUTES_FETCH_REQUEST:
      return loadingList(state, ['mutes']);
    case FOLLOW_REQUESTS_FETCH_REQUEST:
      return loadingList(state, ['follow_requests']);
    case FOLLOWERS_FETCH_SUCCESS:
      return normalizeList(state, ['followers', action.id], action.accounts, action.next);
    case FOLLOWERS_EXPAND_SUCCESS:
      return appendToList(state, ['followers', action.id], action.accounts, action.next);
    case FOLLOWING_FETCH_SUCCESS:
      return normalizeList(state, ['following', action.id], action.accounts, action.next);
    case FOLLOWING_EXPAND_SUCCESS:
      return appendToList(state, ['following', action.id], action.accounts, action.next);
    case REBLOGS_FETCH_SUCCESS:
      return normalizeList(state, ['reblogged_by', action.id], action.accounts);
    case FAVOURITES_FETCH_SUCCESS:
      return normalizeList(state, ['favourited_by', action.id], action.accounts);
    case REACTIONS_FETCH_SUCCESS:
      return state.setIn(['reactions', action.id], ReactionListRecord({
        items: ImmutableOrderedSet(action.reactions.map(_ref => {
          let {
              accounts
            } = _ref,
            reaction = _objectWithoutProperties(_ref, _excluded);
          return ReactionRecord(_objectSpread(_objectSpread({}, reaction), {}, {
            accounts: ImmutableOrderedSet(accounts.map(account => account.id))
          }));
        }))
      }));
    case NOTIFICATIONS_UPDATE:
      return action.notification.type === 'follow_request' ? normalizeFollowRequest(state, action.notification) : state;
    case FOLLOW_REQUESTS_FETCH_SUCCESS:
      return normalizeList(state, ['follow_requests'], action.accounts, action.next);
    case FOLLOW_REQUESTS_EXPAND_SUCCESS:
      return appendToList(state, ['follow_requests'], action.accounts, action.next);
    case FOLLOW_REQUEST_AUTHORIZE_SUCCESS:
    case FOLLOW_REQUEST_REJECT_SUCCESS:
      return removeFromList(state, ['follow_requests'], action.id);
    case BLOCKS_FETCH_SUCCESS:
      return normalizeList(state, ['blocks'], action.accounts, action.next);
    case BLOCKS_EXPAND_SUCCESS:
      return appendToList(state, ['blocks'], action.accounts, action.next);
    case MUTES_FETCH_SUCCESS:
      return normalizeList(state, ['mutes'], action.accounts, action.next);
    case MUTES_EXPAND_SUCCESS:
      return appendToList(state, ['mutes'], action.accounts, action.next);
    case DIRECTORY_FETCH_SUCCESS:
      return normalizeList(state, ['directory'], action.accounts, action.next);
    case DIRECTORY_EXPAND_SUCCESS:
      return appendToList(state, ['directory'], action.accounts, action.next);
    case DIRECTORY_FETCH_REQUEST:
    case DIRECTORY_EXPAND_REQUEST:
      return state.setIn(['directory', 'isLoading'], true);
    case DIRECTORY_FETCH_FAIL:
    case DIRECTORY_EXPAND_FAIL:
      return state.setIn(['directory', 'isLoading'], false);
    case GROUP_MEMBERS_FETCH_SUCCESS:
      return normalizeList(state, ['groups', action.id], action.accounts, action.next);
    case GROUP_MEMBERS_EXPAND_SUCCESS:
      return appendToList(state, ['groups', action.id], action.accounts, action.next);
    case GROUP_REMOVED_ACCOUNTS_FETCH_SUCCESS:
      return normalizeList(state, ['groups_removed_accounts', action.id], action.accounts, action.next);
    case GROUP_REMOVED_ACCOUNTS_EXPAND_SUCCESS:
      return appendToList(state, ['groups_removed_accounts', action.id], action.accounts, action.next);
    case GROUP_REMOVED_ACCOUNTS_REMOVE_SUCCESS:
      return removeFromList(state, ['groups_removed_accounts', action.groupId], action.id);
    case PINNED_ACCOUNTS_FETCH_SUCCESS:
      return normalizeList(state, ['pinned', action.id], action.accounts, action.next);
    case BIRTHDAY_REMINDERS_FETCH_SUCCESS:
      return normalizeList(state, ['birthday_reminders', action.id], action.accounts, action.next);
    case FAMILIAR_FOLLOWERS_FETCH_SUCCESS:
      return normalizeList(state, ['familiar_followers', action.id], action.accounts, action.next);
    default:
      return state;
  }
}